import { render, staticRenderFns } from "./BaseIconInput.vue?vue&type=template&id=6477b8e4&"
import script from "./BaseIconInput.vue?vue&type=script&lang=js&"
export * from "./BaseIconInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports